import type { MailboxInfo } from "owa-client-types";
import isCopilotFeatureEnabled from "./isCopilotFeatureEnabled";
import { getIsCopilotUIDisabled } from "owa-mail-copilot-settings/lib/selectors/getIsCopilotUIDisabled";

/**
 * Determines if Daily Briefing is enabled for the given mailbox.
 */
export function isDailyBriefingEnabled(mailboxInfo: MailboxInfo): boolean {
    return ((isCopilotFeatureEnabled("DailyBriefing", mailboxInfo, true /* skipLanguageCheck */) ??
        false) &&
        !getIsCopilotUIDisabled(mailboxInfo));
}
